<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-xl-3">
        <BranchStatsPanel />
      </div>
      <!-- end col -->
      <div class="col-xl-9">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">All Privileges</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <AllPrivilegeTable></AllPrivilegeTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Create Bank Component
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import AllPrivilegeTable from "../../components/Kleyton/Tables/Privilege/AllPrivilegeTable";

export default {
  page: {
    title: "All Privileges",
    meta: [{ name: "All Privileges", content: window.__env.app.description }]
  },
  components: {
    AllPrivilegeTable,

    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "All Privileges",

      items: [
        {
          text: "Privilege",
          href: "/"
        },
        {
          text: "Create Privilege",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
